import styles from './Image.module.scss';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ImageElement = forwardRef(
  (
    {
      alt,
      className,
      disableLazyLoading,
      height,
      src,
      srcSet,
      width,
      ...props
    },
    ref,
  ) => (
    <img
      alt={alt || ''}
      className={classNames(styles.image, className)}
      height={height}
      loading={disableLazyLoading ? 'eager' : 'lazy'}
      ref={ref}
      src={src}
      srcSet={srcSet}
      width={width}
      {...props}
    />
  ),
);

ImageElement.displayName = 'ImageElement';

const Image = forwardRef(
  (
    {
      alt,
      className = null,
      disableLazyLoading = false,
      href = null,
      src,
      srcSet = null,
      target = '_self',
      ...props
    },
    ref,
  ) => {
    return href ? (
      <a href={href} target={target}>
        <ImageElement
          alt={alt}
          className={className}
          disableLazyLoading={disableLazyLoading}
          ref={ref}
          src={src}
          srcSet={srcSet}
          {...props}
        />
      </a>
    ) : (
      <ImageElement
        alt={alt}
        className={className}
        disableLazyLoading={disableLazyLoading}
        ref={ref}
        src={src}
        srcSet={srcSet}
        {...props}
      />
    );
  },
);

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  disableLazyLoading: PropTypes.bool,
  href: PropTypes.string,
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string,
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
};

Image.displayName = 'Image';

export default Image;
